<template>
<div class="content-main">
    <div class="left-main">
        <div class="title"><span class="color36A9FF">Digital </span><span>Visualization </span></div>
        <div class="swiper-main">
            <div class="swiper-box">
                <swiper :options="swiperOption">
                    <swiper-slide class="swiper-slide" v-for="(item,index) in carouselArr" :key="index">
                        <img :src="item.icon" width="100%" />
                        <div class="child-side-text">
                            <div class="child-text">{{item.text}}</div>
                            <el-link>More</el-link>
                        </div>
                    </swiper-slide>
                    <!-- 分页器 -->
                    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                    <!-- 左右箭头 -->
                    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div> -->
                </swiper>
            </div>
        </div>

    </div>
    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
import data_1 from '@/assets/images/data_1.jpg'
import data_2 from '@/assets/images/data_2.jpg'
import data_3 from '@/assets/images/data_3.jpg'

// Import Swiper styles
export default {
    name: "tagData",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            carouselArr: [{
                    id: 0,
                    text: "外综云服数据监控中心",
                    icon: data_1,
                },
                {
                    id: 1,
                    text: "外综云服供应链数据可视化",
                    icon: data_2,
                },
                {
                    id: 2,
                    text: "四川资阳进出口可视化",
                    icon: data_3,
                }
            ],
            list: [],
            swiperOption: {
                slidesPerView: 3, // 设置slider容器能够同时显示的slides数量; 设置为auto则自动根据slides的宽度来设定数量
                centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
                spaceBetween: 30,
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                //自动轮播
                // autoplay: {
                //     delay: 2000,
                //     //当用户滑动图片后继续自动轮播
                //     disableOnInteraction: false,
                // },
                //开启循环模式
                loop: true
            },
            btnList: [{
                id: 0,
                icon: require("../assets/images/icon_3.png"),
                text: "综合服务"
            }, {
                id: 0,
                icon: require("../assets/images/icon_4.png"),
                text: "金融服务"
            }, {
                id: 0,
                icon: require("../assets/images/icon_5.png"),
                text: "物流服务"
            }],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.child-side-text {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .child-text {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        letter-spacing: 1px;
    }
}

.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;

    .left-main {
        width: 100%;
        height: 100%;
        //background-color: #ccc;
        //padding-left: 240px;
        //padding-top: 160px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        //flex-direction: column;
        .swiper-main {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            //border: 1px red solid;
        }

        .swiper-box {
            width: 1460px;
            height: 530px;
            justify-content: center;
            align-items: center;
            //border:1px red solid;
            overflow: hidden;

        }

        .swiper-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex: 1;

            //border:1px red solid;
            .swiper-wrapper {
                width: 200px !important;

                .swiper-slide-prev,
                .swiper-slide-next {
                    width: 350px !important;
                }

                .swiper-slide-active {
                    width: 700px !important;
                }
            }

            .swiper-slide {
                //width: 400px !important;
                //border: 1px red solid;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {
    width: 100%;
    margin-top: 60px;
    font-size: 60px;
    text-align: center;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 84px;
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt80 {
    margin-top: 80px;
}

.mgb30 {
    margin-bottom: 30px;
}

.mgb100 {
    margin-bottom: 100px;
}

.mgr10 {
    margin-right: 10px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}

.color36A9FF {
    color: #36A9FF;
}
</style>



// WEBPACK FOOTER //
// src/components/tagData.vue